// import config from '../config/config';
import { AxiosResponse } from 'axios';
import { isEmpty } from '../../../library/Core/SmartFunctions';
import logger from '../../../library/Core/logger';
import { axiosClient } from '../../../library/Service/axiosClient';
// import PageConfigService from './page-config.service';
import pageConfig from './PageConfig.json';
import { useContext } from 'react';
import SessionContext from '../../../library/Core/SessionContext';
import { SessionStateType } from '../../../library/Core/SmartTypes';

class GrievanceService {
    static userStatusCode: string;
    static studentId: string;
    static userTypeCode: string;
    static genderCode: string;
    static instituteLogo: string;
    static instituteGroupId: string;
    constructor() {
        // IIFE (Immediately Invoked Function Expression)
        (() => {
            const { sessionState } = useContext(SessionContext);
            GrievanceService.userStatusCode = sessionState?.userStatusCode as any;
            GrievanceService.studentId = sessionState?.studentId as any;
            GrievanceService.userTypeCode = sessionState?.userTypeCode as any;
            GrievanceService.genderCode = sessionState?.genderCode as any;
            GrievanceService.instituteLogo = sessionState?.instituteLogo as any;
            GrievanceService.instituteGroupId = sessionState?.instituteGroupId as any;
            //const { userStatusCode, studentId, userTypeCode, genderCode, instituteLogo: schoolImage } = sessionState as SessionStateType;
        })();

        // Rest of the constructor
    }

    static pageLoader(params: any) {
        const state: any = {};
        const { pageName } = params;
        logger.log(`Loading ${pageName}`);

        return Promise.all([this.getPageConfig()])
            .then((values) => {
                logger.log(`Retrieved values successfully for ${pageName}`);
                state.formConfig = values[0];
                state.data = {
                    ...state.data,
                    grievance: {
                        ...state.data?.grievance,
                        leadType: 'system'
                    }
                };
                state.routeInfo = { pageName };
                return Promise.resolve(state);
            })
            .catch(function (err) {
                logger.log(`Error in loading data for ${pageName} and the error is:`);
                console.log(err);
            });
    }

    static getPageConfig() {
        return Promise.resolve(pageConfig);
    }

    static async save(id: string, type: string, data: any): Promise<any> {
        let result;
        result = await axiosClient().put(`${process.env.REACT_APP_STUDENT_SERVER}/student/${id}/additional-info`, data);

        return Promise.resolve(result);
    }
}
export default GrievanceService;
